// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".combo-detail .content .combo .van-cell{padding:10px 10px;background-color:#f6f7f9;font-size:16px}.combo-detail .content .combo .van-cell .van-cell__title{text-align:left}", ""]);
// Exports
module.exports = exports;
